import { Link, useLocation } from "react-router-dom";
import { Home, LayoutGrid, Sparkles, Heart, ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";

/**
 * Myntra-style mobile bottom nav — 5 items, active state pink pill.
 *   Home · Categories · Source it · Wishlist · Bag
 */
const NAV = [
  { key: "home",       to: "/",                     icon: Home,       label: "Home",       matchExact: true },
  { key: "categories", to: "/collections",          icon: LayoutGrid, label: "Categories" },
  { key: "studio",     to: "/source-on-demand",     icon: Sparkles,   label: "Source it",  accent: true },
  { key: "wishlist",   to: "/wishlist",             icon: Heart,      label: "Wishlist" },
];

const MobileBottomNav = () => {
  const { count, setOpen } = useCart();
  const loc = useLocation();

  const isActive = (it) =>
    it.matchExact ? loc.pathname === it.to : loc.pathname.startsWith(it.to);

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-[70] bg-white border-t border-line grid grid-cols-5"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="mobile-bottom-nav"
    >
      {NAV.map((it) => {
        const active = isActive(it);
        const Icon = it.icon;
        return (
          <Link
            key={it.key}
            to={it.to}
            className="flex flex-col items-center justify-center py-2.5 relative"
            data-testid={`bottomnav-${it.key}`}
          >
            <Icon
              className={`w-[22px] h-[22px] transition-colors ${
                active ? "text-pink" : it.accent ? "text-pink" : "text-ink-soft"
              }`}
              strokeWidth={active ? 2.4 : 1.9}
              fill={active ? "currentColor" : "none"}
            />
            <span
              className={`text-[10px] font-bold uppercase tracking-wide mt-0.5 ${
                active ? "text-pink" : "text-ink-soft"
              }`}
            >
              {it.label}
            </span>
            {active && (
              <span className="absolute top-0 inset-x-6 h-[2px] bg-pink" />
            )}
          </Link>
        );
      })}
      <button
        onClick={() => setOpen(true)}
        className="flex flex-col items-center justify-center py-2.5 relative"
        data-testid="bottomnav-bag"
        aria-label="Bag"
      >
        <div className="relative">
          <ShoppingBag className="w-[22px] h-[22px] text-ink-soft" strokeWidth={1.9} />
          {count > 0 && (
            <span className="absolute -top-1.5 -right-2 bg-pink text-white text-[9px] font-bold rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center">
              {count}
            </span>
          )}
        </div>
        <span className="text-[10px] font-bold uppercase tracking-wide mt-0.5 text-ink-soft">
          Bag
        </span>
      </button>
    </nav>
  );
};

export default MobileBottomNav;
